export default function ($log, $sessionStorage) {

    const API_CALL_ERROR = {
        NETWORKERROR: 'ERR_NETWORK_CONNECTION',
        GENERICERROR: 'There was an issue when completing your request. Please make sure that the Google account you are using is the default Google account in your browser (more about setting an account as default <a target="_blank" href="https://drawpforschool.com/google-slides-add-on/#multi-login-issue-fix">here</a>) or try using the add-on in a private/incognito window',
        QUOTAERROR: '<p>We encountered a Google Services quotas limitation error while executing one of your latest requests. This happened because the Apps Script services have daily quotas and limitations on some features, and it means that you have reached a quota or limitation for your account.<br><br>These quotas are reset on a daily bases. Please try again tomorrow.<br><br>(More information available at: <a target="_blank" href="https://developers.google.com/apps-script/guides/services/quotas">link</a>)</p>',
        MAXEXECUTIONERROR: '<p>We encountered a Google Services quotas limitation error while executing one of your latest requests. This happened because there are too many requests to Apps Script services at once from your account, and it may mean you are using other add-ons in different tabs simultaneously along with the Drawp for School Add-on.<br><br>Please try again in a while.<br><br>(More information available at: <a target="_blank" href="https://developers.google.com/apps-script/guides/services/quotas#exception_messages">link</a>)</p>',
        SERVERERROR: 'There was an issue when completing your request. We are having some issues in our server. Please try again later.'
    };

    const gradeLevels = [
        {
            'label': 'Kindergarten',
            'shortLabel': 'K',
            'index': 0
        },
        {
            'label': 'Grade 1',
            'shortLabel': '1',
            'index': 1
        },
        {
            'label': 'Grade 2',
            'shortLabel': '2',
            'index': 2
        },
        {
            'label': 'Grade 3',
            'shortLabel': '3',
            'index': 3
        },
        {
            'label': 'Grade 4',
            'shortLabel': '4',
            'index': 4
        },
        {
            'label': 'Grade 5',
            'shortLabel': '5',
            'index': 5
        },
        {
            'label': 'Grade 6',
            'shortLabel': '6',
            'index': 6
        },
        {
            'label': 'Grade 7',
            'shortLabel': '7',
            'index': 7
        },
        {
            'label': 'Grade 8',
            'shortLabel': '8',
            'index': 8
        },
        {
            'label': 'Grade 9-10',
            'shortLabel': '9-10',
            'index': 9
        },
        {
            'label': 'Grade 11-12',
            'shortLabel': '11-12',
            'index': 10
        }
    ];

    const scriptTagName = 'script';

    const bootstrapIncludes = `<head>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/css/bootstrap.min.css">
            <script src="https://code.jquery.com/jquery-3.5.1.slim.min.js"></${scriptTagName}>
            <script src="https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/js/bootstrap.bundle.min.js"></${scriptTagName}>
        </head>`;

    const lessonPreviewStyleIncludes = `
        <style>
            .lesson-title {
                text-align: center;
                color: gray;
                margin: 5px 15px;
            }
            .canvases-container{
                padding: 30px 30px 10px 30px;
                background: #4e5865;
                border-radius: 5px;
            }
            .custom-carousel-caption{
                color: #fff;
                text-align: center;
                margin-bottom: -5px;
            }
            .carousel-control-next, .carousel-control-prev{
                width: 6%;
            }
        </style>`;

    const isMultiAccountActive = () => {

        // const multiAccountEl = document.getElementById('multiAccount').textContent.trim();

        // if (multiAccountEl === 'true') {
        //     return true;
        // }

        // if (multiAccountEl === 'false') {
        //     return false;
        // }
        return false;
    };

    const fetchGradeLabel = (gradeIndex) => {

        let result = '';

        const matches = gradeLevels.filter((e) => {
            return e.index === gradeIndex;
        });

        if (matches && matches.length > 0) {
            result = matches[0].label;
        }

        return result;
    };

    const launchCustomPreviewDialog = (htmlString, title, resolve, reject) => {

        if (isMultiAccountActive()) {
            $log.warn('Custom dialog launch prevented, limited functionality.');
            return;
        }

        google.script.run
            .withSuccessHandler((data) => {
                $log.info('Custom dialog launched successfully.');
                if (resolve) {
                    resolve(data);
                }
            })
            .withFailureHandler((error) => {
                if (reject) {
                    reject(error);
                }
            })
            .showCustomDialog(htmlString, title);

    };

    const launchLessonPreviewDialog = (lesson) => {

        const htmlString = `
                ${bootstrapIncludes}
                <body class="lesson-preview-body">
                    <h5 class="lesson-title">${lesson.title}</h5>
                    <div id="lessonCanvasesPreviewCarousel_${lesson.id}" class="carousel slide" data-ride="carousel" data-interval="false">
                        <div class="canvases-container">
                            <div class="carousel-inner">
                                ${lesson.canvases.map((e, index) => {
            return `<div class="carousel-item ${index === 0 ? 'active' : ''}">
                                        <img class="d-block w-100" src="${e.thumbnail}">
                                            <div class="custom-carousel-caption">
                                                <span>${index + 1}/${lesson.canvases.length}</span>
                                            </div>
                                    </div>`;
        }).join('')}
                            </div>
                        </div>
                        <a class="carousel-control-prev" data-target="#lessonCanvasesPreviewCarousel_${lesson.id}" role="button"
                            data-slide="prev" href="javascript:void(0)">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" data-target="#lessonCanvasesPreviewCarousel_${lesson.id}" role="button"
                            data-slide="next" href="javascript:void(0)">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </body>
                ${lessonPreviewStyleIncludes}`;

        const dialogLaunchPromise = new Promise((resolve, reject) => {

            launchCustomPreviewDialog(htmlString, ' ', resolve, reject);
        });

        return dialogLaunchPromise;
    };

    /**
     * 
     * listData => Lesson plan list when moving out of the list to detail view
     * viewType => list or grid
     * premiumFilter => all or premium
     * 
     * */
    const setLessonPlanStateData = (ccssList, filteredListData, viewType, currentPage,
        defaults, subscriptionDays, subscription, skipAnswerSlides, hasNextPage, filterObj, selectedIndex, searchQuery, unFilteredLessons) => {
        // eslint-disable-next-line no-param-reassign
        $sessionStorage.lessonPlanState = {
            'ccssList': ccssList,
            'filteredListData': filteredListData,
            'viewType': viewType,
            'currentPage': currentPage,
            'defaults': defaults,
            'subscriptionDays': subscriptionDays,
            'subscription': subscription,
            'skipAnswerSlides': skipAnswerSlides,
            'hasNextPage': hasNextPage,
            'filterObj': filterObj,
            'selectedIndex': selectedIndex,
            'searchQuery': searchQuery,
            'unFilteredListData': unFilteredLessons,
        };
    };

    const getLessonPlanStateData = () => {
        if ($sessionStorage.lessonPlanState) {
            return $sessionStorage.lessonPlanState;
        }
        return null;
    };

    const removeLessonPlanStataData = () => {
        if ($sessionStorage.lessonPlanState) {
            // eslint-disable-next-line no-param-reassign
            $sessionStorage.lessonPlanState = null;
        }
    };

    removeLessonPlanStataData();

    const setVelazquezStateData = (filteredListData, viewType, currentPage,
        defaults, subscriptionDays, subscription, skipAnswerSlides, hasNextPage, filterObj, selectedIndex, searchQuery, unFilteredLessons) => {
        // eslint-disable-next-line no-param-reassign
        $sessionStorage.velazquezState = {
            'filteredListData': filteredListData,
            'viewType': viewType,
            'currentPage': currentPage,
            'defaults': defaults,
            'subscriptionDays': subscriptionDays,
            'subscription': subscription,
            'skipAnswerSlides': skipAnswerSlides,
            'hasNextPage': hasNextPage,
            'filterObj': filterObj,
            'selectedIndex': selectedIndex,
            'searchQuery': searchQuery,
            'unFilteredListData': unFilteredLessons,
        };
    };

    const getVelazquezStateData = () => {
        if ($sessionStorage.velazquezState) {
            return $sessionStorage.velazquezState;
        }
        return null;
    };

    const removeVelazquezStateData = () => {
        if ($sessionStorage.velazquezState) {
            // eslint-disable-next-line no-param-reassign
            $sessionStorage.velazquezState = null;
        }
    };

    removeVelazquezStateData();

    const errorHandler = (error, scopeObject) => {
        return API_CALL_ERROR.GENERICERROR;

        $log.info(error);
        try {
            const scope = scopeObject;
            scope.progress = null;
            scope.$apply();
        } catch (err) {
            // Nth
        }

        if (isMultiAccountActive() && error === 'ERR_NETWORK_CONNECTION') {
            return API_CALL_ERROR.NETWORKERROR;
        }

        if (typeof (error) === 'string' && error.includes('NetworkError')) {
            return API_CALL_ERROR.NETWORKERROR;
        }

        if (typeof (error) !== 'string' && error.message === 'Failed to fetch') {
            return API_CALL_ERROR.NETWORKERROR;
        }

        if (typeof (error) === 'string' && error.includes('Internal Server Error')) {
            return API_CALL_ERROR.SERVERERROR;
        }

        if (typeof (error) !== 'string' && error.message.includes('Internal Server Error')) {
            return API_CALL_ERROR.SERVERERROR;
        }

        try {
            if (typeof (error) !== 'string') {
                const errorMessage = error.toString();
                if (errorMessage.includes('There are too many scripts running simultaneously for this Google user account')) {
                    return API_CALL_ERROR.MAXEXECUTIONERROR;
                }
            } else if (typeof (error) === 'string' && error.includes('There are too many scripts running simultaneously for this Google user account')) {
                return API_CALL_ERROR.MAXEXECUTIONERROR;
            }
        } catch (err) {
            return API_CALL_ERROR.GENERICERROR;
        }

        try {
            if (typeof (error) !== 'string') {
                const errorMessage = error.toString();
                if (errorMessage.includes('Service invoked too many times for one day')) {
                    return API_CALL_ERROR.QUOTAERROR;
                }
            } else if (typeof (error) === 'string' && error.includes('Service invoked too many times for one day')) {
                return API_CALL_ERROR.QUOTAERROR;
            }
        } catch (err) {
            return API_CALL_ERROR.GENERICERROR;
        }

        return API_CALL_ERROR.GENERICERROR;
    };

    const getActiveAccountEmail = () => {
        return document.getElementById('userEmail').textContent.trim();
    };

    const launchVelazquezPreviewDialog = (velazquez) => {

        const htmlString = `
                ${bootstrapIncludes}
                <body class="velazquez-preview-body">
                    <h5 class="velazquez-title">${velazquez.name}</h5>
                    <div id="velazquezCanvasesPreviewCarousel_${velazquez.id}" class="carousel slide" data-ride="carousel" data-interval="false">
                        <div class="canvases-container">
                            <div class="carousel-inner">
                                ${velazquez.previews.map((e, index) => {
            return `<div class="carousel-item ${index === 0 ? 'active' : ''}">
                                        <img class="d-block w-100" src="${e.replace('moondrawp.xyz', 'drawpforschool.com')}">
                                            <div class="custom-carousel-caption">
                                                <span>${index + 1}/${velazquez.previews.length}</span>
                                            </div>
                                    </div>`;
        }).join('')}
                            </div>
                        </div>
                        <a class="carousel-control-prev" data-target="#velazquezCanvasesPreviewCarousel_${velazquez.id}" role="button"
                            data-slide="prev" href="javascript:void(0)">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" data-target="#velazquezCanvasesPreviewCarousel_${velazquez.id}" role="button"
                            data-slide="next" href="javascript:void(0)">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </body>
                ${lessonPreviewStyleIncludes}`;

        const dialogLaunchPromise = new Promise((resolve, reject) => {

            launchCustomPreviewDialog(htmlString, ' ', resolve, reject);
        });

        return dialogLaunchPromise;
    };

    return ({
        fetchGradeLabel,
        isMultiAccountActive,
        launchCustomPreviewDialog,
        launchLessonPreviewDialog,
        setLessonPlanStateData,
        getLessonPlanStateData,
        errorHandler,
        API_CALL_ERROR,
        getActiveAccountEmail,
        setVelazquezStateData,
        getVelazquezStateData,
        launchVelazquezPreviewDialog,
    });

}